export default __webpack_public_path__ + "static/media/AE3.d91bd7ce.jpg";